var exports = {
  "YL": "Tooltip.module__tooltip___OUVTMU",
  "xQ": "Tooltip.module__tooltipPointer___OUVTMU",
  "rv": "Tooltip.module__tooltipContent___OUVTMU",
  "iU": "Tooltip.module__tooltipContentLarge___OUVTMU" + " " + "Tooltip.module__tooltipContent___OUVTMU",
  "dn": "Tooltip.module__tooltipTop___OUVTMU",
  "L_": "Tooltip.module__tooltipBottom___OUVTMU",
  "Lf": "Tooltip.module__tooltipLeft___OUVTMU",
  "Uu": "Tooltip.module__tooltipRight___OUVTMU",
  "A4": "Tooltip.module__tooltipPrimary___OUVTMU",
  "yH": "Tooltip.module__tooltipPointerBg___OUVTMU",
  "Rp": "Tooltip.module__tooltipRed___OUVTMU",
  "vX": "Tooltip.module__tooltips___OUVTMU",
  "bZ": "Tooltip.module__hoverFloatingTooltipSurface___OUVTMU",
  "IM": "Tooltip.module__triggerWrapper___OUVTMU",
};

module.exports = exports;
